import { render, staticRenderFns } from "./Document.vue?vue&type=template&id=37ecdcb9&scoped=true&"
import script from "./Document.vue?vue&type=script&lang=js&"
export * from "./Document.vue?vue&type=script&lang=js&"
import style0 from "./Document.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Document.vue?vue&type=style&index=1&id=37ecdcb9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ecdcb9",
  null
  
)

export default component.exports